import { ImagePlus, Plus, Video } from "lucide-react";
import { useState } from "react";

import { MultiFileUploadButton } from "@/components/multi-file-upload-button";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useUpdateSKUMutation } from "@/data/mutations";
import { addGalleryItems } from "@/lib/cms";

import { useCMSContext } from "../cms-context";
import { useCMSTabContext } from "../cms-tab-context";

// FIXME: The current structure of the multi file upload button makes handling
// progress visualization difficult.
// Since we're implementing a new toast for this purpose, this version does
// not include any progress state for the uploads.

export const AddContentButton = () => {
  const { sku, pageContent } = useCMSContext();
  const { tabIndex } = useCMSTabContext();
  const updateSKUMutation = useUpdateSKUMutation(sku.id);
  const [open, setOpen] = useState(false);

  const handleFileUploadFinish = (
    uploadedFiles: { url: string; file_name: string }[],
    fileType: "image" | "video",
  ) => {
    setOpen(false);

    updateSKUMutation.mutate({
      page_content: addGalleryItems(
        pageContent,
        tabIndex,
        uploadedFiles,
        fileType,
      ),
    });
  };

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <Button type="button" variant="secondary" className="w-full">
          <Plus className="size-4" /> Add Content
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent side="top" className="w-60">
        <MultiFileUploadButton
          fileType="image"
          onFinish={(uploadedFiles) =>
            handleFileUploadFinish(uploadedFiles, "image")
          }
        >
          {(props) => (
            <DropdownMenuItem
              onClick={(e) => {
                e.preventDefault();
                props.openFilePicker(e);
              }}
            >
              <ImagePlus className="size-4" /> Image File
            </DropdownMenuItem>
          )}
        </MultiFileUploadButton>
        <MultiFileUploadButton
          fileType="video"
          onFinish={(uploadedFiles) =>
            handleFileUploadFinish(uploadedFiles, "video")
          }
        >
          {(props) => (
            <DropdownMenuItem
              onClick={(e) => {
                e.preventDefault();
                props.openFilePicker(e);
              }}
            >
              <Video className="size-4" /> Video URL
            </DropdownMenuItem>
          )}
        </MultiFileUploadButton>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
